import { WorkflowRoleSelectorDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import JobCatalogRoleSelector from 'modules/procurement/components/procurementTypes/Workflows/sidePanels/JobCatalogRoleSelector'
import LegacyRoleSelector from 'modules/procurement/components/procurementTypes/Workflows/sidePanels/LegacyRoleSelector'
import { EntitySelectorComponent } from 'modules/workflows/components/Sidepanel/VariableSelectorTypes'

const RoleSelector: EntitySelectorComponent = ({ value, onChange, error }) => {
  const { company } = useCurrentSession()
  const { data, loading } = useQuery(WorkflowRoleSelectorDocument, {
    variables: { companyId: company.id },
  })

  const isLegacyJobCatalog =
    data?.features?.featuresConnection?.nodes?.find(
      (feature) => feature.name === 'legacy_job_catalog'
    )?.enabled ?? true // Default to legacy if flag not found

  const availableRoles = data?.jobCatalog?.rolesConnection?.nodes || []
  const treeRoles = data?.jobCatalog?.treeNodesConnection?.nodes || []

  if (loading) {
    return null
  }

  if (isLegacyJobCatalog) {
    return (
      <LegacyRoleSelector
        availableRoles={availableRoles}
        value={value}
        onChange={onChange}
        error={error}
        isLoading={loading}
      />
    )
  }

  return (
    <JobCatalogRoleSelector
      treeRoles={treeRoles}
      value={typeof value === 'string' ? value : undefined}
      onChange={onChange}
      isLoading={loading}
    />
  )
}

export default RoleSelector
